<template>
  <div>
    <header-base tab-selected="Home" current-page="Página principal" />
  </div>
</template>

<script>
export default {
  name: 'Home',
};
</script>
